// extracted by css-extract-rspack-plugin
export default {"wrapper":"F7iIm","root":"uD0jK"};